import React, { useState, useEffect } from 'react';
import logo from './logo.svg';
import makeSudokuStruct, { mark, isFill } from './sudoku';
import './App.css';

function App() {
	const [state, setState] = useState({
		state: 'init',
	});
	const select = (x, y) => {
		setState(s => ({...s, selected: [x, y]}))
	}
	const moveSelection = (xdir, ydir) => {
		setState(s => ({...s, selected: [
			Math.max(0, Math.min(8, s.selected[0]+xdir)),
			Math.max(0, Math.min(8, s.selected[1]+ydir)),
		]}))
	}
	const onSubmit = async(e) => {
		e.preventDefault();
		try {
			setState({
				state: 'play',
				level: e.target.level.value,
				struct: await makeSudokuStruct(e.target.level.value),
				selected: [0,0],
			});
		} catch (error) {
			setState({
				state: 'error',
				error: error.message,
				level: e.target.level.value,
			});
			console.error(error);
		}
	}
	const _mark = (num) => {
		setState((s) => {
			const news = mark(s.struct, s.selected[0], s.selected[1], num)
			const filled = isFill(news);
			console.log(filled, 'isfill');
			return {
				...s,
				struct: news,
				state: filled ? 'done' : "play",
			}
		});
	}
	useEffect(() => {
		const list = e => {
			if(/^\d$/.exec(e.key))
				_mark(Number(e.key));
			else if(e.key==='Delete' || e.key==='Backspace')
				_mark(null);
			else if(e.key==='ArrowRight')
				moveSelection(1, 0)
			else if(e.key==='ArrowLeft')
				moveSelection(-1, 0)
			else if(e.key==='ArrowUp')
				moveSelection(0, -1)
			else if(e.key==='ArrowDown')
				moveSelection(0, 1)
			else
				console.log(e.key);
		}
		document.body.addEventListener('keydown', list);
		return () => document.body.removeEventListener('keydown', list);
	}, []);
	return (
		<div className="container">
			{state.state==="play" || state.state==="done" ? (
				<>
					<div className={`game ${state.state==="done"?"done":""}`}>
						{state.struct?.map((i,ii) => (
							<div className="col" key={ii}>
								{i.map((j,jj) => (
									<div className={`cell ${jj%3===2?'b-end':''} ${ii%3===2?'r-end':''} ${state.selected && state.selected[0]===ii && state.selected[1]===jj?'selected':''} ${j.red?'wrong':''} ${j.fixed?'original':''}`} key={jj} onClick={() => select(ii,jj)}>
										{j.num ? j.num : ''}
										{j.chances?.map((c,cc) => (<div className={`ch ch-${cc}`} key={cc}>{c}</div>))}
									</div>
								))}
							</div>
						))}
					</div>
					{state.state==='play'?
						<div className="control-panel">
							{[[1,2,3,4,5],[6,7,8,9,'x']].map(a => (
								<div className="control">
									{a.map(i => (
										<button
											className="key"
											key={i}
											onClick={() => _mark(i==='x'?null:i)}
											disabled={
												state.struct
													[state.selected[0]]
													[state.selected[1]]
													.fixed
												?true:false
											}
										>{i}</button>
									))}
								</div>
							))}
						</div>
					:<div className="control-panel">You Won! <button onClick={() => setState({state: 'init'})}>Play Again?</button></div>}
				</>
			) : state.state==="init" ? (
				<div className="modal-outer">
					<div className="modal-inner">
						<form onSubmit={onSubmit} id="level-form">
							<div className="title">Which level would you prefer?</div>
							<div className="options">
								<label className="">
									<input name="level" value="hard" type="radio" required />
									<div>Hard</div>
								</label>
								<label className="">
									<input name="level" value="medium" type="radio" required />
									<div>Medium</div>
								</label>
								<label className="">
									<input name="level" value="soft" type="radio" required />
									<div>Soft</div>
								</label>
							</div>
							<div className="footer">
								<button type="submit">Start Now</button>
							</div>
						</form>
					</div>
				</div>
			) : null}
		</div>
	);
}

export default App;
